export default "__VITE_ASSET__D4y7XEAP__"